import { Box, Typography } from '@material-ui/core';

const AssaMobile = ({ openDialog }: { openDialog?: boolean }): JSX.Element => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography
          style={{
            fontWeight: openDialog ? 400 : 500,
            fontSize: 15,
          }}
        >
          Asistencia vial
        </Typography>
      </Box>
      <img src="svg/logo_ASSA_movil.svg" alt="assa_movil" width={110} />
    </Box>
  );
};

export default AssaMobile;
